/**
 * Pharmaco Women's Health - Scroll Animations & Interactions
 * Uses IntersectionObserver to trigger animations as elements scroll into view.
 */

// Scroll-triggered animations via IntersectionObserver
const initScrollAnimations = () => {
  // Target all pharmaco animation classes
  const selectors = [
    '.pharmaco-animate-fade-in',
    '.pharmaco-animate-fade-in-up'
  ];
  const animatedElements = document.querySelectorAll(selectors.join(','));

  if (animatedElements.length === 0) return;

  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    animatedElements.forEach(el => {
      el.classList.add('is-visible');
      el.style.opacity = '1';
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -50px 0px',
    threshold: 0.1
  });

  animatedElements.forEach(el => observer.observe(el));
};

// Header scroll behavior — add shadow on scroll
const initHeaderScroll = () => {
  const header = document.querySelector('.pharmaco-header');
  if (!header) return;

  const scrollThreshold = 20;

  const onScroll = () => {
    if (window.pageYOffset > scrollThreshold) {
      header.classList.add('pharmaco-header--scrolled');
    } else {
      header.classList.remove('pharmaco-header--scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // Check initial state
};

// Mobile menu toggle
const initMobileMenu = () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  const openClass = 'pharmaco-header__mobile-menu--open';

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.contains(openClass);
    menu.classList.toggle(openClass);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains(openClass)) {
      menu.classList.remove(openClass);
      toggle.setAttribute('aria-expanded', 'false');
    }
  });

  // Close on link click
  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      menu.classList.remove(openClass);
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
};

// Smooth scroll for anchor links
const initSmoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerOffset = 100;
        const elementPosition = target.offsetTop;
        window.scrollTo({
          top: elementPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    });
  });
};

// Initialize all on DOM ready
const init = () => {
  initScrollAnimations();
  initHeaderScroll();
  initMobileMenu();
  initSmoothScroll();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Reinitialize on Shopify theme editor section load
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initScrollAnimations();
  });
}
